<ng-template #busy>
  <div class="center"><mat-spinner diameter="40"></mat-spinner></div>
</ng-template>


<div *ngIf="!loading; else busy" class="freight-container">

  <!-- header ----------------------------------------------------------- -->
  <div class="freight-info">

    <!-- type-17 header -->
    <ng-container *ngIf="header?.lading_type === LadingType.LT17; else hdr16">
      <div><strong>Store #:</strong> {{ storeNumber || '—' }}</div>
      <div><strong>Alt Ref:</strong> {{ header.alternate_reference || '—' }}</div>
      <div>
        <strong>Status:</strong>
        <span *ngIf="allDelivered; else pend17" class="confirm-yes">
          <i class="fas fa-check-circle"></i> Delivered
        </span>
        <ng-template #pend17>
          <span class="confirm-no"><i class="fas fa-clock"></i> Pending</span>
        </ng-template>
      </div>
    </ng-container>

    <!-- type-16 header -->
    <ng-template #hdr16>
      <div><strong>Customer PO:</strong> {{ header.customer_po || '—' }}</div>
      <div><strong>Alt Ref:</strong> {{ header.alternate_reference || '—' }}</div>
      <div>
        <strong>Confirmation:</strong>
        <span *ngIf="header?.delivery_confirmation; else pend16" class="confirm-yes">
          <i class="fas fa-check-circle"></i> Uploaded to Technogym SFTP
        </span>
        <ng-template #pend16>
          <span class="confirm-no"><i class="fas fa-clock"></i> Pending</span>
        </ng-template>
      </div>
    </ng-template>
    <button mat-stroked-button color="primary" *ngIf="canReviewConfirmation"
      [disabled]="confirmationReviewLoading" (click)="openConfirmationReview()">
      <i class="fas fa-file-circle-check"></i>
      {{ confirmationReviewLoading ? 'Checking confirmation…' : (header?.delivery_confirmation ? 'View Upload Review' : 'Review SFTP Upload') }}
    </button>

  </div>
  <p *ngIf="confirmationMessage" class="confirmation-message" role="status">{{ confirmationMessage }}</p>

  <!-- layout ----------------------------------------------------------- -->
  <div class="freight-layout">

    <!-- requirements card -->
    <mat-card *ngIf="requirements.length" class="panel requirements-panel">
      <mat-card-header>
        <mat-card-title>
          <i class="fas fa-clipboard-list"></i> Delivery Requirements
          <span *ngIf="hasDiscrepancy" class="warn">
            <i class="fas fa-exclamation-triangle"></i> Discrepancy
          </span>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <table mat-table [dataSource]="requirements" class="full-table">
          <ng-container matColumnDef="item_code">
            <th mat-header-cell *matHeaderCellDef>Item Code</th>
            <td mat-cell *matCellDef="let r">{{ r.item_code }}</td>
          </ng-container>
          <ng-container matColumnDef="quantity">
            <th mat-header-cell *matHeaderCellDef class="right">Qty</th>
            <td mat-cell *matCellDef="let r" class="right">{{ r.quantity }}</td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef class="center">Action</th>
            <td mat-cell *matCellDef="let r" class="center">
              <button
                mat-icon-button
                color="primary"
                *ngIf="!isFulfilled(r) && !header?.delivery_confirmation"
                (click)="onAddProductForRequirement(r)"
                matTooltip="Add to Truck">
                <i class="fas fa-plus"></i>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['item_code','quantity','action']"></tr>
          <tr mat-row        *matRowDef="let row; columns:['item_code','quantity','action']"></tr>
        </table>
      </mat-card-content>
    </mat-card>

    <!-- type-16 packages -->
    <ng-container *ngIf="header?.lading_type !== LadingType.LT17; else type17Tpl">

      <mat-card class="panel packages-panel" [class.full-width]="!hasDiscrepancy">
        <mat-card-header>
          <mat-card-title><i class="fas fa-truck"></i> On the Truck</mat-card-title>
          <span class="spacer"></span>
          <button
            mat-stroked-button
            color="primary"
            *ngIf="packages.length"
            (click)="openPackageLabels()"
            matTooltip="Preview and print warehouse package labels">
            <i class="fas fa-tags"></i>
            Package Labels
          </button>
          <button
            mat-mini-fab
            color="accent"
            *ngIf="allowMultiProductPackaging && !header?.delivery_confirmation"
            (click)="addPackage()"
            matTooltip="Add Package">
            <i class="fas fa-plus"></i>
          </button>
        </mat-card-header>

        <mat-card-content>
          <div *ngIf="!packages.length" class="empty-state">No packages loaded.</div>

          <!-- single-product table -->
          <table
            mat-table
            [dataSource]="packages"
            class="full-table"
            *ngIf="packages.length && !allowMultiProductPackaging; else multiTpl">

            <ng-container matColumnDef="model">
              <th mat-header-cell *matHeaderCellDef>Model</th>
              <td mat-cell *matCellDef="let p">{{ p.products[0].product_code }}</td>
            </ng-container>

            <ng-container matColumnDef="serial">
              <th mat-header-cell *matHeaderCellDef>Serial #</th>
              <td mat-cell *matCellDef="let p">{{ p.products[0].product_serial_number || '—' }}</td>
            </ng-container>

            <ng-container matColumnDef="description">
              <th mat-header-cell *matHeaderCellDef>Description</th>
              <td mat-cell *matCellDef="let p">{{ p.products[0].description || '—' }}</td>
            </ng-container>

            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef class="center">Actions</th>
              <td mat-cell *matCellDef="let p" class="center">
                <button mat-icon-button color="warn" (click)="removePackage(p)">
                  <i class="fas fa-trash"></i>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="['model','serial','description','action']"></tr>
            <tr mat-row        *matRowDef="let row; columns:['model','serial','description','action']"></tr>
          </table>

          <!-- multi-product accordion -->
          <ng-template #multiTpl>
            <mat-accordion multi>
              <mat-expansion-panel *ngFor="let pkg of packages">
                <mat-expansion-panel-header>
                  <mat-panel-title>Package</mat-panel-title>
                  <mat-panel-description>
                    {{ pkg.products.length }} product(s)
                    <span class="spacer"></span>
                    <button
                      mat-icon-button
                      color="warn"
                      (click)="removePackage(pkg); $event.stopPropagation()">
                      <i class="fas fa-trash"></i>
                    </button>
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <table class="nested-table full-table">
                  <thead>
                    <tr>
                      <th>Model</th><th>Serial #</th><th>Description</th><th class="center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let pr of pkg.products">
                      <td>{{ pr.product_code }}</td>
                      <td>{{ pr.product_serial_number || '—' }}</td>
                      <td>{{ pr.description || '—' }}</td>
                      <td class="center">
                        <button mat-icon-button (click)="onEditProduct(pr, pkg)">
                          <i class="fas fa-edit"></i>
                        </button>
                        <button mat-icon-button color="warn" (click)="onDeleteProduct(pr, pkg)">
                          <i class="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div class="panel-actions" *ngIf="allowMultiProductPackaging">
                  <button mat-stroked-button color="primary" (click)="onAddProduct(pkg)">
                    <i class="fas fa-plus"></i> Add Product
                  </button>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </ng-template>
        </mat-card-content>
      </mat-card>
    </ng-container>

    <!-- type-17 packages -->
    <ng-template #type17Tpl>
      <mat-card class="panel packages-panel" [class.full-width]="!hasDiscrepancy">
        <mat-card-header>
          <mat-card-title><i class="fas fa-truck"></i> On the Truck</mat-card-title>
          <div class="grid-toolbar">
            <!-- <mat-form-field appearance="outline" class="quick-filter">
              <mat-label>Quick Filter</mat-label>
              <input
                matInput
                #quickFilterInput
                placeholder="Search products…"
                (input)="onQuickFilterChanged(quickFilterInput.value)" />
            </mat-form-field> -->
          </div>
          <span class="spacer"></span>
          <button
            mat-stroked-button
            color="primary"
            *ngIf="packages.length"
            (click)="openPackageLabels()"
            matTooltip="Preview and print warehouse package labels">
            <i class="fas fa-tags"></i>
            Package Labels
          </button>
        </mat-card-header>

        <mat-card-content>
          <ag-grid-angular
            class="ag-theme-alpine type17-grid"
            [rowData]="packages"
            [columnDefs]="masterColumnDefs"
            [masterDetail]="true"
            [detailCellRendererParams]="detailCellRendererParams"
            [detailRowAutoHeight]="true"
            [style.height]="gridHeight">
          </ag-grid-angular>
        </mat-card-content>
      </mat-card>
    </ng-template>

  </div>
</div>

<ng-template #confirmationReviewDialog>
  <h2 mat-dialog-title class="confirmation-title">Review confirmation</h2>
  <mat-dialog-content *ngIf="confirmationReview as review" class="confirmation-review">
    <div class="review-heading">
      <span>PO <strong>{{ review.customer_po }}</strong> · Lading {{ review.lading_id }}</span>
      <span *ngIf="review.already_uploaded" class="review-status">Uploaded · Read only</span>
    </div>

    <div class="review-summary">
      <span><strong>{{ review.required_units }}</strong> requested</span>
      <span><strong>{{ review.linked_units }}</strong> linked</span>
      <span><strong>{{ review.audited_units }}</strong> audited</span>
    </div>

    <h3 *ngIf="review.discrepancies.length" class="review-section-title">Item codes</h3>
    <table *ngIf="review.discrepancies.length" class="review-table">
      <thead><tr><th>Item code</th><th>Requested</th><th>Linked</th></tr></thead>
      <tbody><tr *ngFor="let row of review.discrepancies">
        <td class="code">{{ row.item_code || '(blank)' }}</td><td>{{ row.requested }}</td><td>{{ row.linked }}</td>
      </tr></tbody>
    </table>

    <h3 *ngIf="confirmationLineChanges.length" class="review-section-title">Order lines</h3>
    <table *ngIf="confirmationLineChanges.length" class="review-table">
      <thead><tr><th>Item code</th><th>Sales order</th><th>Stored line</th><th>Requested line</th></tr></thead>
      <tbody><tr *ngFor="let row of confirmationLineChanges">
        <td class="code">{{ row.stored_code }}</td><td class="code">{{ row.sales_order }}</td>
        <td class="code">{{ row.stored_line }}</td><td class="code">{{ row.line }}</td>
      </tr></tbody>
    </table>

    <details *ngIf="review.substitutions.length" class="review-package">
      <summary>Package details</summary>
      <table class="review-table">
        <thead><tr><th>Item code</th><th>Serial</th><th>Package UUID</th></tr></thead>
        <tbody><tr *ngFor="let row of review.substitutions">
          <td class="code">{{ row.stored_code }}</td><td class="code">{{ row.serial || '—' }}</td><td class="code">{{ row.package_uuid }}</td>
        </tr></tbody>
      </table>
    </details>

    <p *ngIf="!review.discrepancies.length && !review.substitutions.length" class="review-matched">All codes and quantities match.</p>
    <div *ngIf="review.blockers.length && !review.already_uploaded" class="review-blockers" role="alert">
      <strong>Cannot upload yet</strong>
      <ul><li *ngFor="let blocker of review.blockers">{{ blocker }}</li></ul>
    </div>
    <div class="review-footnote"><span>Inventory stays unchanged.</span><span>SFTP file: <span class="code">{{ review.customer_po }}.txt</span></span></div>
    <mat-form-field *ngIf="!review.already_uploaded" appearance="outline" class="review-note">
      <mat-label>Approval note</mat-label>
      <textarea matInput rows="2" maxlength="1000" [(ngModel)]="confirmationNote" [disabled]="confirmationUploading" placeholder="Reason for approval"></textarea>
    </mat-form-field>
    <p *ngIf="confirmationError" class="review-blockers" role="alert">{{ confirmationError }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="review-actions">
    <button mat-button [disabled]="confirmationUploading" (click)="closeConfirmationReview()">{{ confirmationReview?.already_uploaded ? 'Close' : 'Cancel' }}</button>
    <button mat-raised-button color="primary" class="review-upload-button" [disabled]="confirmationReview?.already_uploaded || !confirmationReview?.can_upload || !confirmationNote.trim() || confirmationUploading" (click)="approveConfirmation()">
      {{ confirmationUploading ? 'Uploading…' : 'Approve & Upload' }}
    </button>
  </mat-dialog-actions>
</ng-template>
